import { ContentfulSupplierBanner } from '@jbhi-fi/apis/src/contentful/types';
import { WithProductProviderProps } from '../../context/ProductProvider';
import { SupplierProductBannerProduct, SupplierProductBannerProps } from '../../SupplierProductBanner/types';
import { TermsAndConditionsTransformer } from './TermsAndConditionsTransformer';

export abstract class SupplierProductBannerTransformer {
  static toSupplierProductBannerProps = (
    entry: ContentfulSupplierBanner
  ): WithProductProviderProps<SupplierProductBannerProps> => {
    return {
      overallEndDate: entry.fields.overallEndDate ? new Date(entry.fields.overallEndDate) : undefined,
      contentProducts: createProductsArray(entry),
      desktopImage: entry.fields.desktopImage,
      mobileImage: entry.fields.mobileImage,
      color: entry.fields.textAndButtonColourBlack ? 'Black' : 'White',
      shouldShowNewAtJbBadge: !!entry.fields.showNewAtJbBadge,
      tagType: entry.fields.tagType === 'Badge' ? 'Badge' : 'Banner tag',
      badgeStyle: entry.fields.badgeStyle === 'Star burst' ? 'Star burst' : 'Red flag',
      badge: (entry.fields.badge as SupplierProductBannerProps['badge']) ?? undefined,
      shouldShow1ProductInBoxWithImage: !!entry.fields.show1ProductInBoxWithImage,

      trackingData: {
        id: entry?.fields?.name ?? '',
        type: 'carousel',
      },
      termsAndConditions: TermsAndConditionsTransformer.toTermsAndConditions(entry?.fields?.termsConditions),
    };
  };
}

const createProductsArray = (entry: ContentfulSupplierBanner): Array<SupplierProductBannerProduct> => {
  const products: Array<SupplierProductBannerProduct> = [];
  if (entry.fields.product1?.[0]) {
    products.push({
      variantId: entry.fields.product1[0],
      enableEAPriceBox: !!entry.fields.showEaInPriceBox1,
      endDate: entry.fields.endDate1 ? new Date(entry.fields.endDate1) : undefined,
    });
  }
  if (entry.fields.product2?.[0]) {
    products.push({
      variantId: entry.fields.product2[0],
      enableEAPriceBox: !!entry.fields.showEaInPriceBox2,
      endDate: entry.fields.endDate2 ? new Date(entry.fields.endDate2) : undefined,
    });
  }
  return products;
};
